import styled from 'styled-components';

export const Blur = styled.div`
    background: linear-gradient(to bottom, var(--background-color) 8rem, transparent 100%);
    display: block;
    height: 100%;
    position: absolute;
    top: 0; bottom: 0;
    width: 100%;
`;